import type { i18n as I18nInstance } from "i18next";
import { z } from "zod";

export function installZodErrorMap(i18n: I18nInstance) {
  const t = (key: string, options?: Record<string, unknown>) =>
    i18n.t(key, { ns: "validation", ...options });

  z.config({
    customError: (issue) => {
      switch (issue.code) {
        case "invalid_type":
          if (issue.expected === "string" && issue.input == null) {
            return { message: t("required") };
          }
          return { message: t("invalidType", { expected: issue.expected }) };
        case "too_small":
          if (issue.origin === "string" && issue.minimum === 1) {
            return { message: t("required") };
          }
          if (issue.origin === "string") {
            return { message: t("tooShort", { min: issue.minimum }) };
          }
          if (issue.origin === "array") {
            return { message: t("tooFewItems", { min: issue.minimum }) };
          }
          return { message: t("tooSmall", { min: issue.minimum }) };
        case "too_big":
          if (issue.origin === "string") {
            return { message: t("tooLong", { max: issue.maximum }) };
          }
          return { message: t("tooBig", { max: issue.maximum }) };
        case "invalid_format":
          if (issue.format === "email") return { message: t("invalidEmail") };
          if (issue.format === "url") return { message: t("invalidUrl") };
          return { message: t("invalidFormat") };
        case "invalid_value":
          return { message: t("invalidValue") };
        default:
          return undefined;
      }
    },
  });
}
